import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { AccountReducer } from '../types/account.types';

const selectAccount =
  () =>
  (state: RootState): AccountReducer =>
    state.account;

const selectIsAuthenticated = () => createSelector(selectAccount(), (account) => !!account.userId);

export const accountSelectors = {
  selectAccount,
  selectIsAuthenticated,
};
